<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/ceo_message/ceo_picture_2.jpeg'" alt="" class="main-image">
            <p class="image-text">{{ "ceo_message.CEO's Message" | translate }}</p>
        </div>
        <div class="paragraph">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3" *ngIf="isEnglish()">
                   <img [src]="baseApiUrl + '/uploads/images/ceo_message/semicolumn.svg'" alt="">

                    <h4 style="font-weight: bold; margin-left: 25px;">{{ text_en.title }}</h4>

                    <p class="highlight">{{ text_en.highlight_1 }}</p>
                    <p>{{ text_en.text_1_1 }}</p>
                    <p>{{ text_en.text_1_2 }}</p>

                    <p class="highlight">{{ text_en.highlight_2 }}</p>
                    <p>{{ text_en.text_2_1 }}</p>
                    <p>{{ text_en.text_2_2 }}</p>

                    <p class="highlight">{{ text_en.highlight_3 }}</p>
                    <p>{{ text_en.text_3_1 }}</p>
                    <p>{{ text_en.text_3_2 }}</p>
                    <p>{{ text_en.text_3_3 }}</p>

                    <p class="highlight">{{ text_en.highlight_4 }}</p>
                    <p>{{ text_en.text_4_1 }}</p>

                    <p class="highlight">{{ text_en.highlight_5 }}</p>
                    <p>{{ text_en.text_5_1 }}</p>

                    <p class="highlight">{{ text_en.highlight_6 }}</p>
                    <p>{{ text_en.text_6_1 }}</p>

                    <p class="highlight">{{ text_en.highlight_7 }}</p>
                    <p>{{ text_en.text_7_1 }}</p>
                    <p>{{ text_en.text_7_2 }}</p>

                </div>
                 <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3" *ngIf="isKhmer()">
                   <img [src]="baseApiUrl + '/uploads/images/ceo_message/semicolumn.svg'" alt="">

                    <h4 style="font-weight: bold; margin-left: 25px;">{{ text_kh.title }}</h4>

                    <p class="highlight">{{ text_kh.highlight_1 }}</p>
                    <p>{{ text_kh.text_1_1 }}</p>
                    <p>{{ text_kh.text_1_2 }}</p>

                    <p class="highlight">{{ text_kh.highlight_2 }}</p>
                    <p>{{ text_kh.text_2_1 }}</p>
                    <p>{{ text_kh.text_2_2 }}</p>

                    <p class="highlight">{{ text_kh.highlight_3 }}</p>
                    <p>{{ text_kh.text_3_1 }}</p>
                    <p>{{ text_kh.text_3_2 }}</p>
                    <p>{{ text_kh.text_3_3 }}</p>

                    <p class="highlight">{{ text_kh.highlight_4 }}</p>
                    <p>{{ text_kh.text_4_1 }}</p>

                    <p class="highlight">{{ text_kh.highlight_5 }}</p>
                    <p>{{ text_kh.text_5_1 }}</p>

                    <p class="highlight">{{ text_kh.highlight_6 }}</p>
                    <p>{{ text_kh.text_6_1 }}</p>

                    <p class="highlight">{{ text_kh.highlight_7 }}</p>
                    <p>{{ text_kh.text_7_1 }}</p>
                    <p>{{ text_kh.text_7_2 }}</p>

                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>